import React from 'react';

export default {
  title: 'How do you plan to use the loan?',
  label: 'What is your primary reason for taking the loan?',
  loanForAssetsFCLabel: {
    title: () => (
      <>
        As part of your <b>primary</b> loan reason are you looking to buy any of
        the following?
      </>
    ),
    subtitle: () => (
      <>
        If more than one option applies, please select the option that will
        require the most funds.
      </>
    )
  },
  assetFinance: {
    title: 'Asset details',
    paragraph: () => (
      <>
        <b>Purchasing more than one asset?</b>
        <br />
        Please provide details for the asset that will require the most funds.
        You will be able to discuss financing other assets with an account
        manager once your application is complete.
      </>
    ),
    valueCents: 'How much does the primary asset cost? (optional)',
    valueCentsLabel: 'Amount',
    make: 'What is the make of the asset? (optional)',
    makeLabel: 'Make',
    model: 'What is the model of the asset? (optional)',
    modelLabel: 'Model',
    newAsset: 'Is the asset brand new?',
    monthsStatus: 'Must be between 0 - 11 months',
    yearsStatus: 'Must be between 0 - 99 years'
  }
};
